
<div class="raptor-interstitial">
  <div class="grid margin-top-xxsmall">
    <div class="cell cell-small-col-span-6 cell-medium-col-span-6 cell-medium-col-start-2 cell-large-col-span-8 cell-large-col-start-3">

      <div class="text-center">
        <div class="flex flex-justify-center margin-top-xxlarge margin-bottom-xxlarge">
          <div class="partner-logo"></div>
        </div>
        <h1 *ngIf="data && data.heading">{{ data.heading }}</h1>
        <mat-spinner *ngIf="data && data.settings && data.settings.icon === 'spinner'" diameter="28" class="margin-top-xmedium margin-bottom-xmedium"></mat-spinner>
        <img *ngIf="data && data.settings && data.settings.icon !== 'spinner'" src="{{ data.settings.icon }}" height="50" class="margin-top-xmedium margin-bottom-xmedium" />
      </div>

      <div *ngIf="styles && styles.length > 0" class="grid">
        <ng-container *ngFor="let content of data.content; let contentIndex = index;">
          <div class="cell cell-medium-col-span-4 cell-medium-col-start-3 cell-small-col-start-2 cell-large-col-span-6 cell-large-col-start-4 sequence-tick">
            <div class="flex flex-content-center steps" [ngStyle]="styles[contentIndex]">
              <span class="flex-grow">{{ content.text }}</span>

              <mat-icon class="check_circle_outline tick" [ngStyle]="styles[contentIndex]"></mat-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
